import React from 'react';
import BlankLayout from '../layouts/BlankLayout';
import DefaultLayout from '../layouts/DefaultLayout';
import TripLayout from '../layouts/TripLayout';
import DirectoryLayout from '../layouts/DirectoryLayout';
import VehicleTrackLayout from '../layouts/VehicleTrackLayout';

interface LayoutWrapperProps {
  layout: string;
  children: React.ReactNode;
}

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ layout, children }) => {
  switch (layout) {
    case 'BlankLayout':
      return <BlankLayout>{children}</BlankLayout>;
    case 'DefaultLayout':
      return <DefaultLayout>{children}</DefaultLayout>;
    case 'TripLayout':
      return <TripLayout>{children}</TripLayout>;
    case 'DirectoryLayout':
      return <DirectoryLayout>{children}</DirectoryLayout>;
    case 'VehicleTrackLayout':
      return <VehicleTrackLayout>{children}</VehicleTrackLayout>;
    default:
      return <>{children}</>;
  }
};

export default LayoutWrapper;
